module.exports = __webpack_public_path__ + "static/media/1015124.5015e9a1.jpg";